import React from "react";

import cn from "classnames";

import { Activity, EntityType } from "@mapmycustomers/shared/types/entity";

import EntityLink from "@app/component/EntityLink";

import styles from "./AssociatedRecordLink.module.scss";

interface Props {
  activity: Activity;
  className?: string;
}

const AssociatedRecordLink: React.FC<Props> = ({ activity, className }) => {
  if (activity.account) {
    return (
      <EntityLink
        className={cn(styles.container, className)}
        entityId={activity.account.id}
        entityType={EntityType.COMPANY}
        legacy={false}
        showIcon={false}
      >
        {activity.account.name}
      </EntityLink>
    );
  }

  if (activity.contact) {
    return (
      <EntityLink
        className={cn(styles.container, className)}
        entityId={activity.contact.id}
        entityType={EntityType.PERSON}
        legacy={false}
        showIcon={false}
      >
        {activity.contact.name}
      </EntityLink>
    );
  }

  if (activity.deal) {
    return (
      <EntityLink
        className={cn(styles.container, className)}
        entityId={activity.deal.id}
        entityType={EntityType.DEAL}
        legacy={false}
        showIcon={false}
      >
        {activity.deal.name}
      </EntityLink>
    );
  }

  return null;
};

export default AssociatedRecordLink;
